import { sqOpenPageList } from '@/modules/sqmall/constant'

// 由于出现循环依赖，项目无法启动，所以单独拉一个文件
export const checkIsInOpenPage = () => {
    const pathname = window.location.pathname
    if (pathname === '/') {
        return true
    }
    for (let i = 0; i < sqOpenPageList.length; i++) {
        const item = sqOpenPageList[i]
        if (pathname.indexOf(item) > -1) {
            return true
        }
    }
    return false
}
